import {useEffect, useState} from 'react';

/**
 * Trigger a rerender in the caller at a fixed interval.
 *
 * @example
 * function Date(): JSX.Element {
 *   usePollingRerender(1000);
 *   return <span>{new Date().toLocaleTimeString()}</span>; // rerenders every second
 * }
 *
 * @storybook https://dev--622a4c57262ed1003a5a57fa.chromatic.com/?path=/story/custom-hooks-usepollingrerender--basic
 */
export default function usePollingRerender(delayMs: number): void {
  const [_, setIncrement] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      // Use the setter function to avoid a stale closure value of `increment`
      setIncrement((increment) => increment + 1);
    }, delayMs);
    return () => {
      clearInterval(interval);
    };
  }, [delayMs]);
}
